import React from "react";
import { TextWrapperSpan, Wrapper } from "../../constants/common/StyledGlobalConstants";
import SuccessIcon from "../../assets/icons/Success.png";
import CloseIcon from "../../assets/icons/NotificationClose.png";
import WarningIcon from "../../assets/icons/NewWarningIcon.png";
import InformationIcon from "../../assets/icons/Information_icon.svg";
import WarningInfoIcon from "../../assets/icons/warningiconsvg.svg";
import cfstErrorIcon from "../../assets/icons/cfstErrorIcon.png";
import PropTypes from "prop-types";

const CPNotification = ({
  isOpen,
  width,
  height,
  notificationType,
  closeButton,
  onClose,
  margin,
  children,
  restoredAccount,
  role = "alert",
  ariaHiddenValue = "false",
}) => {
  const getBackgroundColor = () => {
    if (restoredAccount) return "#E3F2FD"; // New color for restoredAccount
    if (notificationType === "info") return "#D6EEFB";
    if (notificationType === "success") return "#D6F2E0";
    if (notificationType === "error") return "#FBE4D7";
    if (notificationType === "cfsterror") return "#FFECE0";
    if (notificationType === "warning") return "#FFF9DE";
  };
  const getAlignment = () => {
    if (notificationType === "info" || notificationType === "error") {
      return "baseline";
    } else if (notificationType === "warning" || notificationType === "cfsterror") {
      return "flex-start";
    } else {
      return "center";
    }
  };
  return (
    <>
      {isOpen ? (
        <Wrapper
          role={role}
          width={width}
          height={height}
          background={getBackgroundColor}
          borderRadius="4px"
          display="flex"
          flexDirection="row"
          alignItems={getAlignment}
          justifyContent="space-between"
          padding="12px"
          flexWrap="nowrap"
          margin={margin}
          aria-hidden={ariaHiddenValue}
        >
          <Wrapper display="flex" flexDirection="row" alignItems={getAlignment} justifyContent="flex-start" flexWrap="nowrap" gap="8px" flex="1 0 0">
            {" "}
            {notificationType === "success" ? <img src={SuccessIcon} alt="success" /> : null}
            {notificationType === "error" ? <img src={WarningIcon} alt="warning message" /> : null}
            {notificationType === "info" && <img src={InformationIcon} alt="information notification message" />}
            {notificationType === "warning" ? <img src={WarningInfoIcon} aria-label="warning" alt="warning" /> : null}
            {notificationType === "cfsterror" ? <img src={cfstErrorIcon} aria-label="error" alt="error" /> : null}
            <TextWrapperSpan
              style={{
                "line-height": "20px",
                fontSize: "0.875rem",
                width: "100%",
                letterSpacing: "0",
              }}
            >
              {children}
            </TextWrapperSpan>
            <div>
              {closeButton && (
                <button
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                  }}
                  onClick={() => onClose()}
                  aria-label="Close notification"
                >
                  <img src={CloseIcon} alt="Close" />
                </button>
              )}
            </div>
          </Wrapper>
        </Wrapper>
      ) : null}
    </>
  );
};

CPNotification.defaultProps = {
  isOpen: false,
  width: "100%",
  height: "44px",
  notificationType: "success",
  closeButton: false,
  children: <div></div>,
  onClose: () => {},
  restoredAccount: false, // Default value for restoredAccount
};

CPNotification.propTypes = {
  isOpen: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  notificationType: PropTypes.oneOf([
    "success",
    "error",
    "info",
    "warning",
    "cfsterror",
  ]),
  closeButton: PropTypes.bool,
  onClose: PropTypes.func,
  margin: PropTypes.string,
  children: PropTypes.node,
  restoredAccount: PropTypes.bool,
  role: PropTypes.string,
  ariaHiddenValue: PropTypes.string,
};

export default CPNotification;